import http from '../http/http';
import URL from '../constant/URL';

const { LEARNING } = URL.API;

// 사용자 주제학습 대주제 리스트 조회
export const themaListAPI = async (data) => {
  let result = null;
  const { locale, learnerId } = data;
  await http.request({
    url: `${LEARNING.THEMA}/language/${locale}/member/${learnerId}`,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      throw error;
    }
  });

  return result;
}

// 사용자 주제학습 소주제 리스트 조회
export const stageListAPI = async (data) => {
  let result = null;
  const { locale, learnerId, thmaCd } = data;
  await http.request({
    url: `${LEARNING.THEMA}/language/${locale}/member/${learnerId}/thema/${thmaCd}/stage`,
    success: (resp, code) => {
      result = { resp, code }
    },
    error: (error) => {
      throw error;
    }
  });

  return result;
}